import countries from "../assets/json/countries.json";
function useCountries() {
  const getCountriesList = () => countries;
  return {
    getCountriesList
  };
}
var useCountries_default = useCountries;
export {
  useCountries_default as default
};
